// src/services/productsAnalytics.api.js
import { adminApiRequest } from "./adminApi";

export const getProductsAnalytics = (query = "") => {
  return adminApiRequest(`/admin/products-analytics${query}`);
};